module.exports = __webpack_public_path__ + "media/applicants/iphone@3x-a54aa5f5.png";